/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RemovalPoint} from '../../../_models/removal-point';
import {ToastrService} from 'ngx-toastr';
import {RemovalPointService} from '../../../_services/removal-point.service';
import {DialogHelper} from '../../../_helpers/dialog-helper';
import {Helpers} from '../../../helpers';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {EDIT} from '../../../_enums/constants';
import {I18nService, UPDATE_SUCCESS} from '../../../_services/i18n.service';

@Component({
  selector: 'app-adapter-removal-point',
  templateUrl: './adapter-removal-point.component.html',
  styleUrls: ['./adapter-removal-point.component.scss']
})
export class AdapterRemovalPointComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              COMPONENT I/O                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() data: RemovalPoint;
  @Input() position: number;

  @Output() updated = new EventEmitter();

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    private dialogHelper: DialogHelper,
    private i18n: I18nService,
    private removalPointService: RemovalPointService,
    private toastr: ToastrService
  ) {
  }

  ngOnInit() {
    // This is intentional
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUES GETTERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get isFavorite(): boolean {
    return this.data && this.data.favorite;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                   LISTENERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public changeState(e): void {
    if (e.checked) {
      this.showEnable();
    } else {
      this.showDisable();
    }
  }

  public showDisable(): void {
    this.dialogHelper.showRemovalPointDisable(this.data).subscribe((res: boolean) => {
      if (res) {
        this.updateRemovalPoint(this.data.id, {enabled: 0, favorite: 0});
      } else {
        this.updated.emit();
      }
    });
  }

  public showEnable(): void {
    this.dialogHelper.showRemovalPointEnable(this.data).subscribe((res: boolean) => {
      if (res) {
        this.updateRemovalPoint(this.data.id, {enabled: 1});
      } else {
        this.updated.emit();
      }
    });
  }

  public showFavorite(): void {
    this.dialogHelper.showRemovalPointFavorite(this.data).subscribe((res: boolean) => {
      if (res) {
        this.favoriteRemovalPoint();
      } else {
        this.updated.emit();
      }
    });
  }

  public showEditForm(): void {
    if (this.data) {
      this.dialogHelper.showRemovalPointForm({
        mode: EDIT,
        removalPoint: this.data,
        thirdPartyId: this.data.thirdPartyId
      }).subscribe(() => {
        this.updated.emit();
      });
    }
  }

  public updatePhones(): void {
    this.updated.emit();
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                   ASYNC                                                                                            ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public favoriteRemovalPoint() {
    Helpers.setLoading(true);

    this.removalPointService.updateFavorite(this.data.id, {version: 0.3}).subscribe(
      (res: HttpResponse<RemovalPoint>) => this.handleSuccess(res),
      (err: HttpErrorResponse) => this.handleError(err));
  }

  private updateRemovalPoint(rpId: number, data: any) {
    Helpers.setLoading(true);

    this.removalPointService.update(rpId, data, {version: 0.3}).subscribe(
      (res: HttpResponse<RemovalPoint>) => this.handleSuccess(res),
      (err: HttpErrorResponse) => this.handleError(err));
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                   PRIVATE METHODS                                                                                  ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  testf() {
    return "ok"
  }

  private handleSuccess(res: HttpResponse<RemovalPoint>): void {
    Helpers.setLoading(false);
    this.updated.emit(res.body);
    this.toastr.success(this.i18n.get(UPDATE_SUCCESS));
  }

  private handleError(err: HttpErrorResponse): void {
    Helpers.setLoading(false);
    this.updated.emit();
    this.toastr.error(`${err.status} - ${this.i18n.get(err.status)}`);
  }

}
